export default "__VITE_ASSET__CfRK7Bgp__"